import { Base } from '@studiometa/js-toolkit';

/**
 * Accordion component.
 */
export default class Konami extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Konami',
  };

  static pattern = 'ArrowUpArrowUpArrowDownArrowDownArrowLeftArrowRightArrowLeftArrowRight';

  static scriptPath = '/wp-content/themes/studiometa/static/konami/ritschfisch.js';

  queue = [];

  /**
   * Keyed event to react to.
   * @param {import('@studiometa/js-toolkit').KeyServiceProps} props
   */
  keyed({ event, isUp }) {
    if (!isUp) {
      return;
    }

    this.queue = this.queue.slice(-9);
    this.queue.push(event.key);

    if (this.queue.join('') === Konami.pattern) {
      this.s = document.createElement('script');
      this.s.setAttribute('src', Konami.scriptPath);
      this.s.setAttribute('id', 'konami');
      document.body.append(this.s);
    }

    if (document.querySelector('#konami') && event.key === 'Escape') {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }
  }
}
